import React from 'react';

import { SkeletonBlock } from '../../../../components/skeleton/skeleton';

export default function StoreDetailSkeleton() {
  return (
    <div className="mx-auto max-w-5xl space-y-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-4">
          <SkeletonBlock className="h-16 w-16 shrink-0 rounded-md" />
          <div className="space-y-2">
            <SkeletonBlock className="h-8 w-48 rounded-md" />
            <SkeletonBlock className="h-4 w-full max-w-md rounded" />
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <SkeletonBlock className="h-9 w-32 rounded-full" />
          <SkeletonBlock className="h-9 w-36 rounded-full" />
        </div>
      </div>
      {[0, 1].map((s) => (
        <div key={s} className="space-y-4">
          <div className="flex justify-between gap-4">
            <SkeletonBlock className="h-7 w-40 rounded" />
            <SkeletonBlock className="h-9 w-20 rounded-full" />
          </div>
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            {[0, 1, 2].map((c) => (
              <div
                key={c}
                className="overflow-hidden rounded-md border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800"
              >
                <SkeletonBlock className="h-20 w-full rounded-none" />
                <div className="space-y-3 p-4">
                  <SkeletonBlock className="h-4 w-full rounded" />
                  <SkeletonBlock className="h-4 w-full max-w-[10rem] rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
